import { Injectable } from '@angular/core';
import { fetchAndSaveFile, saveBlobAsFile } from '@core/utils/helpers/file-download.helper';

/**
 * Saves PDF bytes to the user's disk. Stateless and `root`-provided — it operates only on the
 * data handed to it, so it is safe to share across every viewer instance. The anchor/blob save
 * mechanics live in the shared `file-download.helper`.
 */
@Injectable({ providedIn: 'root' })
export class PdfDownloadService {
  /** Trigger a browser download for the given bytes under `fileName`. */
  download(data: Uint8Array | ArrayBuffer, fileName: string): void {
    // `Uint8Array<ArrayBufferLike>` (TS 5.7+) isn't structurally a `BlobPart`; the bytes are always
    // a valid blob source at runtime, so assert rather than copy the (potentially large) buffer.
    const part = data as BlobPart;
    saveBlobAsFile(new Blob([part], { type: 'application/pdf' }), this.ensurePdfExtension(fileName));
  }

  /** Download directly from a URL (used when the source was a remote URL we never buffered). */
  downloadFromUrl(url: string, fileName: string): Promise<void> {
    return fetchAndSaveFile(url, this.ensurePdfExtension(fileName));
  }

  private ensurePdfExtension(fileName: string): string {
    return /\.pdf$/i.test(fileName) ? fileName : `${fileName}.pdf`;
  }
}
